import type { MessageV2Dto } from "@/api/types";

export function getCommunityPostDocumentTitle(
  post: Pick<MessageV2Dto, "title" | "autoTranslation" | "deletedAt"> | undefined,
  fallback: string,
): string {
  if (!post || post.deletedAt) {
    return fallback;
  }

  return post.autoTranslation?.title.trim() || post.title.trim() || fallback;
}
